export const buildColumnDefs = ( gridKey, schema, registry ) => {
    if ( !schema?.cols?.length ) {
        return [];
    }

    let storedCols = typeof( schema.cols ) === 'string' ? JSON.parse( schema.cols ) : schema.cols;
    return storedCols.map( ( col ) => {
        const base = {
            field: col.field,
            headerName: col.headerName,
            // flex: col.flex ?? 1,
            width: col.width ?? 120,
        };

        const helpers = registry[col.type] ?? {};
        return { ...base, ...helpers, ...col.overrides };
    } );
};